import React, { useEffect } from "react";

import Favicon from "react-favicon";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { Outlet } from "react-router-dom";

import GlobalStyles from "src/global-style";
import { ID_RECAPTCHA } from "src/root/pages/utils/constants";
import Favico from "Vendor_resources/images/favicon.ico";

import * as S from "./Page.styles";

const RootPage = () => {
  useEffect(() => {
    document.getElementById("pre-loading")?.remove();
    document.getElementById("fallback")?.remove();
  }, []);

  return (
    <GoogleReCaptchaProvider reCaptchaKey={ID_RECAPTCHA ?? ""}>
      <Favicon url={Favico} />
      <GlobalStyles />
      <S.Layout>
        <S.Content>
          <Outlet />
        </S.Content>
      </S.Layout>
    </GoogleReCaptchaProvider>
  );
};

export default RootPage;
